import React from "react";
import { PawPrint, MessageCircle, Ticket, Lightbulb, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const items = [
  { icon: MessageCircle, title: "Customer Support", cta: "Chat now" },
  { icon: Ticket, title: "Ticket Support", cta: "Send ticket" },
  { icon: Lightbulb, title: "Free Insight", cta: "Read Article" },
];

const NeedSupport = () => {
  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <Reveal animation="rubberBand">
          <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
            <PawPrint className="h-5 w-5" /> Need More Support
          </span>
        </Reveal>
        <Reveal animation="fadeInUp" delay={100}>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
            Discover Helpful Answers from Our Veterinary Experts
          </h2>
        </Reveal>
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {items.map((it, i) => {
          const Icon = it.icon;
          return (
            <Reveal key={it.title} animation="fadeInUp" delay={i * 90} className="group rounded-[28px] bg-pawelle-bg p-8 text-center transition-all duration-300 hover:bg-pawelle-primary">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-white text-pawelle-primary transition-colors group-hover:bg-white/15 group-hover:text-white">
                <Icon className="h-8 w-8" />
              </div>
              <h3 className="mt-6 font-display text-[22px] font-semibold text-pawelle-ink transition-colors group-hover:text-white">{it.title}</h3>
              <p className="mt-3 font-body text-[15px] leading-relaxed text-pawelle-body transition-colors group-hover:text-white/85">
                Dapibus orci rutrum sit praesent bibendum ullamcorper consectetuer elit sodales
              </p>
              <a href="#" className="mt-5 inline-flex items-center gap-1 font-display text-[15px] font-medium text-pawelle-primary transition-all group-hover:text-white group-hover:gap-2">
                {it.cta} <ArrowRight className="h-4 w-4" />
              </a>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};

export default NeedSupport;
